import Field from "./Field";

const OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
  { value: "unsure", label: "Not sure, but my body is side-eyeing this" },
];

export default function PatternStep({ state, update }) {
  return (
    <>
      <div>
        <p className="ks-kicker mb-3">Question</p>
        <h3 className="ks-h3 mb-5">Have I felt this way with this person before?</h3>
        <div className="space-y-3" role="radiogroup" aria-label="Have I felt this way with this person before?">
          {OPTIONS.map((opt) => {
            const checked = state.s3_felt_before === opt.value;
            return (
              <div
                key={opt.value}
                role="radio"
                tabIndex={0}
                aria-checked={checked}
                className="ks-radio-row"
                data-checked={checked}
                data-testid={`pattern-option-${opt.value}`}
                onClick={() => update({ s3_felt_before: opt.value })}
                onKeyDown={(e) => {
                  if (e.key === " " || e.key === "Enter") {
                    e.preventDefault();
                    update({ s3_felt_before: opt.value });
                  }
                }}
              >
                <span className="ks-radio-dot" />
                <span className="ks-check-label">{opt.label}</span>
              </div>
            );
          })}
        </div>
      </div>

      <Field
        label="What keeps repeating?"
        value={state.s3_repeating}
        onChange={(v) => update({ s3_repeating: v })}
        testId="field-s3-repeating"
        placeholder="The loop. The same line. The same feeling after."
        rows={5}
      />
    </>
  );
}
